/**
 * 成本构成组件
 */
import React from 'react';
import { Typography, Progress, Space } from 'antd';
import {
  UserOutlined,
  ToolOutlined,
  GoldOutlined
} from '@ant-design/icons';
import { formatMoney } from '../../utils/budgetUtils';

const { Text, Title } = Typography;

interface CostBreakdownProps {
  stats: any;
  isMobile?: boolean;
}

const CostBreakdown: React.FC<CostBreakdownProps> = ({
  stats,
  isMobile = false
}) => {
  const workTimeCost = stats?.summary?.costBreakdown?.workTimeCost || 0;
  const equipmentCost = stats?.summary?.costBreakdown?.equipmentCost || 0;
  const materialCost = stats?.summary?.costBreakdown?.materialCost || 0;

  const workTimePercent = stats?.summary?.costPercentage?.workTimePercentage || 0;
  const equipmentPercent = stats?.summary?.costPercentage?.equipmentPercentage || 0;
  const materialPercent = stats?.summary?.costPercentage?.materialPercentage || 0;

  const costItems = [
    {
      icon: <UserOutlined style={{ color: '#1677ff' }} />,
      label: '人工成本',
      cost: workTimeCost,
      percent: workTimePercent,
      color: '#1677ff'
    },
    {
      icon: <ToolOutlined style={{ color: '#52c41a' }} />,
      label: '机械成本',
      cost: equipmentCost,
      percent: equipmentPercent,
      color: '#52c41a'
    },
    {
      icon: <GoldOutlined style={{ color: '#fa8c16' }} />,
      label: '材料成本',
      cost: materialCost,
      percent: materialPercent,
      color: '#fa8c16'
    }
  ];

  return (
    <div style={{ marginBottom: isMobile ? 16 : 24 }}>
      <Title level={5} style={{ marginBottom: 16, fontSize: isMobile ? 14 : 16 }}>
        成本构成
      </Title>
      
      {costItems.map((item, index) => (
        <div key={index} style={{ marginBottom: 12 }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: 4
          }}>
            <Space size={8}>
              {item.icon}
              <Text style={{ fontSize: isMobile ? 13 : 14 }}>{item.label}</Text>
            </Space>
            <Space size={8}>
              <Text strong style={{ color: item.color, fontSize: isMobile ? 13 : 14 }}>
                {formatMoney(item.cost, false)}
              </Text>
              <Text type="secondary" style={{ fontSize: isMobile ? 11 : 12 }}>
                ({item.percent.toFixed(1)}%)
              </Text>
            </Space>
          </div>
          <Progress
            percent={item.percent}
            strokeColor={item.color}
            showInfo={false}
            size="small"
          />
        </div>
      ))}
    </div>
  );
};

export default CostBreakdown;
